import type { ColumnDef } from "@tanstack/react-table";
import { createFileRoute } from "@tanstack/react-router";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";

import type { Customer } from "~/providers/customer-provider";
import { DataTable } from "~/components/miscellaneous/data-table";
import { DataTableColumnHeader } from "~/components/miscellaneous/data-table-column-header";
import { useCustomer } from "~/hooks/use-customer";

export const Route = createFileRoute("/_main/customers/")({
  component: CustomersPage,
});

function CustomersPage() {
  const { t } = useTranslation("common");
  const { customers } = useCustomer();
  const columns: ColumnDef<Customer>[] = [
    {
      id: t("Customers.email"),
      accessorKey: "email",
      filterFn: "includesString",
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t("Customers.email")} />
      ),
      cell: ({ row: { original: customer } }) => {
        return <p>{customer.email}</p>;
      },
    },
    {
      id: t("Customers.booking_amount"),
      accessorKey: "amountOfBookings",
      filterFn: "includesString",
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Customers.booking_amount")}
        />
      ),
      cell: ({ row: { original: customer } }) => {
        return <p>{customer.amountOfBookings}</p>;
      },
    },
    {
      id: t("Customers.last_booking"),
      accessorKey: "latestBooking",
      filterFn: "includesString",
      size: 10,
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t("Customers.last_booking")}
        />
      ),
      cell: ({ row: { original: customer } }) => {
        return (
          <p>
            {customer.latestBooking ? format(customer.latestBooking, "Pp") : ""}
          </p>
        );
      },
    },
  ];

  return (
    <div className="max-w-7xl p-2 w-full mx-auto flex flex-col gap-4 overflow-auto">
      <DataTable columns={columns} data={customers} />
    </div>
  );
}
